import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'

export type HospitalSlaConfigProps = {
  id?: string,
  tipo: 'HoraUtil' | 'HoraCorrida',
  horaInicio: number | string,
  horaFim: number | string
}

export type HospitalSlaModalProps =
  | 'REGISTER_SLA_CONFIG'
  | 'REGISTER_SLA'
  | 'EDIT_SLA'
  | 'EDIT_SLA_CONFIG'
  | 'DELETE'

export type SolicitacaoSituacaoEnum =
  | 'EmCotacao'
  | 'AnalisePreAutorizacao'
  | 'PendenteDeEnvioRoboDeAutorizacao'
  | 'PendenciaRespondida'
  | 'AguardandoOperadora'
  | 'ContestacaoMedica'
  | 'AnalisePosCotacao'
  | 'AnalisePreCotacao'
  | 'PreAgendamento'
  | 'Enviado'
  | 'Pendente'
  | 'CancelamentoSolicitado'
  | 'RevisaoCirurgica'
  | 'RevisaoCirurgicaAutorizacao';

export type HospitalSlaProps = {
  id?: string,
  solicitacaoSituacao: SolicitacaoSituacaoEnum,
  quantidadeHorasCriterioNormal: number | string,
  quantidadeHorasCriterioAlerta: number | string,
  possuiOpme?: boolean,
  carater?: 'Urgencia' | 'EletivoAutorizacao' | 'EletivoSemAutorizacao'
}

@Module({ namespaced: true, name: 'SuporteHospitalSlaStore' })
export default class SuporteHospitalSlaStore extends VuexModule {
  private getDefaultHospitalSlaConfig: HospitalSlaConfigProps = {
    horaFim: '',
    horaInicio: '',
    tipo: 'HoraUtil',
  }

  private getDefaultHospitalSla: HospitalSlaProps = {
    quantidadeHorasCriterioAlerta: '',
    quantidadeHorasCriterioNormal: '',
    solicitacaoSituacao: 'AguardandoOperadora',
    possuiOpme: false,
  }

  public solicitacaoSituacoes = []
  public hospitalId: string = ''
  public hospitalSlaConfig: HospitalSlaConfigProps = this.getDefaultHospitalSlaConfig
  public hospitalSla: HospitalSlaProps[] = []
  public newHospitalSlaConfig: HospitalSlaConfigProps = this.getDefaultHospitalSlaConfig
  public newHospitalSla: HospitalSlaProps = this.getDefaultHospitalSla
  public modal: { isOpen: boolean, target: HospitalSlaModalProps } = {
    isOpen: false,
    target: 'EDIT_SLA_CONFIG',
  }


  @Mutation
  setSolicitacaoSituacoes(value: []) {
    this.solicitacaoSituacoes = value
  }

  @Mutation
  setModal(value: { isOpen: boolean, target: HospitalSlaModalProps }) {
    this.modal = value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setHospitalSlaConfig(value: HospitalSlaConfigProps) {
    this.hospitalSlaConfig = value
  }

  @Mutation
  clearHospitalSlaConfig() {
    this.hospitalSlaConfig = this.getDefaultHospitalSlaConfig
  }

  @Mutation
  setNewHospitalSlaConfig(value: HospitalSlaConfigProps) {
    this.newHospitalSlaConfig = value
  }

  @Mutation
  clearNewHospitalSlaConfig() {
    this.newHospitalSlaConfig = this.getDefaultHospitalSlaConfig
  }

  @Mutation
  setHospitalSla(value: HospitalSlaProps[]) {
    this.hospitalSla = value
  }

  @Mutation
  clearHospitalSla() {
    this.hospitalSla = []
  }

  @Mutation
  setNewHospitalSla(value: HospitalSlaProps) {
    this.newHospitalSla = value
  }

  @Mutation
  clearNewHospitalSla() {
    this.newHospitalSla = this.getDefaultHospitalSla
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action({ commit: 'setSolicitacaoSituacoes' })
  async getSolicitacaoSituacoes() {
    const response = await Apis.Agendamento.SuporteApi.getSolicitacaoSituacoes()
    if (response.success) {
      return response.data
    }
    return []
  }

  @Action({ commit: 'setHospitalSlaConfig' })
  async getHospitalSlaConfig(hospitalId: string): Promise<HospitalSlaConfigProps> {
    const response = await Apis.Agendamento.SuporteApi.getHospitalSlaConfig(hospitalId)
    if (response.success) {
      return response.data as HospitalSlaConfigProps
    }
    return this.getDefaultHospitalSlaConfig
  }

  @Action
  async upsertHospitalSlaConfig() {
    const response = await Apis.Agendamento.SuporteApi.upsertHospitalSlaConfig(this.hospitalId, this.newHospitalSlaConfig)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'SLA atualizado com sucesso!', icon: 'done', color: '#2E7D32' })
      if (!this.hospitalSlaConfig.id) {
        await this.context.dispatch('getHospitalSlaConfig', this.hospitalId)
      } else {
        this.context.commit('setHospitalSlaConfig', this.newHospitalSlaConfig)
      }
      return response
    }
    return { success: false, message: 'Ocorreu um erro na requisição.' }
  }

  @Action({ commit: 'setHospitalSla' })
  async getHospitalSla(hospitalSlaConfigId: string): Promise<HospitalSlaProps[]> {
    const response = await Apis.Agendamento.SuporteApi.getHospitalSla(this.hospitalId, hospitalSlaConfigId)
    if (response.success) {
      return response.data as HospitalSlaProps[]
    }
    return []
  }

  @Action
  async upsertHospitalSla() {
    const payload = this.newHospitalSla.id ? this.newHospitalSla : { ...this.newHospitalSla, hospitalSlaConfigId: this.hospitalSlaConfig.id }
    const response = await Apis.Agendamento.SuporteApi.upsertHospitalSla(this.hospitalId, payload)
    if (response.success) {
      const toastMessage = this.newHospitalSla.id ? 'SLA atualizado com sucesso!' : 'SLA cadastrado com sucesso!'
      EventBus.$emit('setSnackbar', { show: true, text: toastMessage, icon: 'done', color: '#2E7D32' })
      await this.context.dispatch('getHospitalSla', this.hospitalSlaConfig ? this.hospitalSlaConfig.id : '')
      return response
    }
    EventBus.$emit('setSnackbar', { show: true, text: `${response.message || 'Ocorreu um erro na requisição.'}`, icon: 'done', color: '#C62828' })
    return { success: false, message: 'Ocorreu um erro na requisição.' }
  }

  @Action
  async deleteHospitalSla() {
    if (!this.newHospitalSla.id) return { success: false, message: 'Hospital SLA não encontrado.' }
    const response = await Apis.Agendamento.SuporteApi.deleteHospitalSla(this.hospitalId, this.newHospitalSla.id)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'SLA excluído com sucesso!', icon: 'done', color: '#2E7D32' })
      await this.context.dispatch('getHospitalSla', this.hospitalSlaConfig ? this.hospitalSlaConfig.id : '')
      return response
    }
    EventBus.$emit('setSnackbar', { show: true, text: `${response.message || 'Ocorreu um erro na requisição.'}`, icon: 'done', color: '#C62828' })
    return { success: false, message: 'Ocorreu um erro na requisição.' }
  }
}
